import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { TypedFormBuilder, TypedFormGroup } from 'formsafe';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  dutyTimeExceeds14Hours,
  endTimeMustBeGreaterThanStartTime,
  endTimeMustNotExeed30MinutesFromNow,
  flightLogManaged,
  justificationRequiredForDutyTimesExceeding14Hours,
} from 'src/app/duty-logs/duty-log-form-validators';
import { DutyOffParams } from 'src/app/shared/flight-log-api/duty-logs/duty-log-client.service';
import { DutyLogEntity } from 'src/store/duty-log/duty-log.model';
import { getValueChanges } from 'src/util/angular/ng-forms-helpers';
import { field, getValidationErrorsChangesDeep } from 'src/util/angular/ng-forms-validation';
import { kendoDateTime24HourFormat } from 'src/util/dateLib';
import { getOrElse } from 'src/util/values';
export interface DutyOffFormParams {
  currentShift: DutyLogEntity;
  prevEntryEndTime?: Date;
}
@Component({
  selector: 'fl-duty-off-form',
  templateUrl: './duty-off-form.component.html',
  styleUrls: ['./duty-off-form.component.scss'],
})
export class DutyOffFormComponent implements OnInit {
  @Input()
  public params: DutyOffFormParams;

  public dateTimeFormat = kendoDateTime24HourFormat;
  public form: TypedFormGroup<DutyOffParams>;
  public errors$: Observable<string[]>;
  public dutyTimeExceeds14Hours$: Observable<boolean>;

  constructor(private fb: TypedFormBuilder) {}

  public ngOnInit() {
    const shift = this.params.currentShift;
    this.form = this.fb.group<DutyOffParams>(
      {
        id: [shift.id, flightLogManaged],
        baseId: [shift.baseId, field('Base', { required: true })],
        aircraftId: [shift.aircraftId, field('Aircraft', { required: true })],
        employeeId: shift.employeeId,
        dutyPeriodStartTime: [shift.dutyPeriodStartTime, field('Duty on time', { required: true })],
        dutyPeriodEndTime: [
          getOrElse(shift.dutyPeriodEndTime, new Date()),
          field('Duty off time', { required: true }),
        ],
        comments: [shift.comments],
        justification: shift.justification,
      },
      {
        validator: Validators.compose([
          justificationRequiredForDutyTimesExceeding14Hours,
          endTimeMustBeGreaterThanStartTime,
          endTimeMustNotExeed30MinutesFromNow,
        ]),
      },
    );
    this.errors$ = getValidationErrorsChangesDeep(this.form);
    this.dutyTimeExceeds14Hours$ = getValueChanges(this.form).pipe(map(dutyTimeExceeds14Hours));
  }
}
